import type { FunctionComponent } from "react";

import type { ShowInVariant, SwapCondition } from "scmp-app/components/header/features/styles";
import { useHomepageLogoLinkProps } from "scmp-app/components/header/hooks";

import { Container, StyledLogoLink, StyledScmpStyleLogoFlag } from "./styles";

export type HeaderFeaturesStyleLogoLinkProps = {
  shouldSwap?: boolean;
  showIn?: ShowInVariant;
  showOnSwap?: SwapCondition;
};

export const HeaderFeaturesStyleLogoLink: FunctionComponent<HeaderFeaturesStyleLogoLinkProps> = ({
  shouldSwap,
  showIn,
  showOnSwap,
}) => {
  const homepageLogoLinkProps = useHomepageLogoLinkProps();

  return (
    <Container $shouldSwap={shouldSwap} $showIn={showIn} $showOnSwap={showOnSwap}>
      <StyledLogoLink {...homepageLogoLinkProps}>
        <StyledScmpStyleLogoFlag />
      </StyledLogoLink>
    </Container>
  );
};

HeaderFeaturesStyleLogoLink.displayName = "HeaderFeaturesStyleLogoLink";
